module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./packages/lui-label/theme/lui-label.global.scss
// module id = 231
// module chunks = 0 1 32